export const FETCH_INOVICE_MONTHS_REQUEST = 'FETCH_INOVICE_MONTHS_REQUEST'
export const FETCH_INOVICE_MONTHS_SUCCESS = 'FETCH_INOVICE_MONTHS_SUCCESS'
export const FETCH_INOVICE_MONTHS_FAILED = 'FETCH_INOVICE_MONTHS_FAILED'
export const FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST = 'FETCH_INVOICE_ANNUAL_SUMMARY_REQUEST'
export const FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS = 'FETCH_INVOICE_ANNUAL_SUMMARY_SUCCESS'
export const FETCH_INVOICE_ANNUAL_SUMMARY_FAILED = 'FETCH_INVOICE_ANNUAL_SUMMARY_FAILED'
export const DOWNLOAD_INVOICE_PDF_REQUEST = 'DOWNLOAD_INVOICE_PDF_REQUEST'
export const DOWNLOAD_INVOICE_PDF_SUCCESS = 'DOWNLOAD_INVOICE_PDF_SUCCESS'
export const DOWNLOAD_INVOICE_PDF_FAILED = 'DOWNLOAD_INVOICE_PDF_FAILED'
export const FETCH_SELECTED_YEAR = 'FETCH_SELECTED_YEAR'

// 일괄 다운로드
export const FETCH_BULK_LATEST_MONTH_REQUEST = 'FETCH_BULK_LATEST_MONTH_REQUEST'
export const FETCH_BULK_LATEST_MONTH_SUCCESS = 'FETCH_BULK_LATEST_MONTH_SUCCESS'
export const FETCH_BULK_LATEST_MONTH_FAILED = 'FETCH_BULK_LATEST_MONTH_FAILED'
export const REQUEST_BULK_DOWNLOAD_REQUEST = 'REQUEST_BULK_DOWNLOAD_REQUEST'
export const REQUEST_BULK_DOWNLOAD_SUCCESS = 'REQUEST_BULK_DOWNLOAD_SUCCESS'
export const REQUEST_BULK_DOWNLOAD_FAILED = 'REQUEST_BULK_DOWNLOAD_FAILED'
export const FETCH_BULK_JOBS_REQUEST = 'FETCH_BULK_JOBS_REQUEST'
export const FETCH_BULK_JOBS_SUCCESS = 'FETCH_BULK_JOBS_SUCCESS'
export const FETCH_BULK_JOBS_FAILED = 'FETCH_BULK_JOBS_FAILED'
export const UPDATE_BULK_JOB = 'UPDATE_BULK_JOB'
